
const lodash = require("lodash");

export function effectForUpdatingRestFieldsBasedOnItems(pageStateDummy) {
  let needsUpdate = false;
  let total_weight = 0;
  let total_amount = 0;
  let total_pkgs = 0;
  let updatedPageState = {};
  pageStateDummy["item_in"].forEach((item) => {
    let weight = parseFloat(item.weight);
    let pkgs = parseFloat(item.pkgs);
    let amount = parseFloat(item.amount);
    if (!isNaN(amount)) {
      total_amount += amount;
    }
    if (!isNaN(weight) && !isNaN(pkgs)) {
      total_weight += weight;
    }
    if (!isNaN(pkgs)) {
      total_pkgs += pkgs;
    }
  });
  if(process.env.REACT_APP_CLIENT != "nrab" && process.env.REACT_APP_CLIENT != "xpress" && process.env.REACT_APP_CLIENT != "guru") {
    if (total_weight != parseFloat(pageStateDummy["charge_weight"])) {
      updatedPageState["charge_weight"] = String(total_weight);
      needsUpdate = true;
    }
  }
  if(process.env.REACT_APP_CLIENT == "guru") {
    if (total_weight != parseFloat(pageStateDummy["actual_weight"])) {
      updatedPageState["actual_weight"] = String(total_weight);
      needsUpdate = true;
    }
  }
  if (total_amount != parseFloat(pageStateDummy["freight"])) {
    updatedPageState["freight"] = String(total_amount);
    needsUpdate = true;
  }
  if (total_pkgs != parseFloat(pageStateDummy["no_of_package"])) {
    updatedPageState["no_of_package"] = String(total_pkgs);
    needsUpdate = true;
  }
  return [needsUpdate, updatedPageState];
}

export function effectForUpdatingTotalAmount(pageStateDummy) {
  let needsUpdate = false;
  let freight = pageStateDummy["freight"];
  let hamali = pageStateDummy["hamali"];
  let door_del_charge = pageStateDummy["door_del_charge"];
  let bilty_charge = pageStateDummy["bilty_charge"];
  let other_amount = pageStateDummy["other_amount"];
  let lc_charge = pageStateDummy["lc_charge"];
  let total_amount = pageStateDummy["total_amount"];
  let rto = pageStateDummy["rto"]
  let loading_charge = pageStateDummy["loading_charge"]
  let unloading_charge = pageStateDummy["unloading_charge"]
  let advance = pageStateDummy["advance"]
  let detention = pageStateDummy["detention"]
  let updatedPageState = {};
  let oda_charge = pageStateDummy["oda_charge"]
  let labour_charge = pageStateDummy["labour_charge"]
  let pop_charge = pageStateDummy["pop_charge"]
  let detenstion_charge = pageStateDummy["detenstion_charge"]
  let return_charge = pageStateDummy["return_charge"]
  let csd_charge = pageStateDummy["csd_charge"]
  let dk_charge = pageStateDummy["dk_charge"]

  if (freight == "") {
    freight = 0;
  } else {
    freight = parseFloat(freight);
  }

  if (hamali == "") {
    hamali = 0;
  } else {
    hamali = parseFloat(hamali);
  }
  if (lc_charge == "") {
    lc_charge = 0;
  } else {
    lc_charge = parseFloat(lc_charge);
  }
  if (door_del_charge == "") {
    door_del_charge = 0;
  } else {
    door_del_charge = parseFloat(door_del_charge);
  }

  if (bilty_charge == "") {
    bilty_charge = 0;
  } else {
    bilty_charge = parseFloat(bilty_charge);
  }

  if (other_amount == "") {
    other_amount = 0;
  } else {
    other_amount = parseFloat(other_amount);
  }

  if (rto == "") {
    rto = 0;
  } else {
    rto = parseFloat(rto);
  }

  if (loading_charge == "") {
    loading_charge = 0;
  } else {
    loading_charge = parseFloat(loading_charge);
  }

  if (unloading_charge == "") {
    unloading_charge = 0;
  } else {
    unloading_charge = parseFloat(unloading_charge);
  }
  
  if (advance == "") {
    advance = 0;
  } else {
    advance = parseFloat(advance);
  }

  if (detention == "") {
    detention = 0;
  } else {
    detention = parseFloat(detention);
  }

  if (oda_charge == "") {
    oda_charge = 0;
  } else {
    oda_charge = parseFloat(oda_charge);
  }

  if (labour_charge == "") {
    labour_charge = 0;
  } else {
    labour_charge = parseFloat(labour_charge);
  }

  if (pop_charge == "") {
    pop_charge = 0;
  } else {
    pop_charge = parseFloat(pop_charge);
  }

  if (detenstion_charge == "") {
    detenstion_charge = 0;
  } else {
    detenstion_charge = parseFloat(detenstion_charge);
  }

  if (return_charge == "") {
    return_charge = 0;
  } else {
    return_charge = parseFloat(return_charge);
  } 
  
  if (csd_charge == "") {
    csd_charge = 0;
  } else {
    csd_charge = parseFloat(csd_charge);
  } 

   if (dk_charge == "") {
    dk_charge = 0;
  } else {
    dk_charge = parseFloat(dk_charge);
  } 

  if (total_amount == "") {
    total_amount = 0;
  } else {
    total_amount = parseFloat(total_amount);
  }
  if(pageStateDummy.is_crossing == "N"){
    if(process.env.REACT_APP_CLIENT == "gdala_log") {
      if (
        total_amount !=
        Math.round(freight + hamali + door_del_charge + bilty_charge + other_amount + lc_charge)
      ) {
        total_amount =
        Math.round(freight + hamali + door_del_charge + bilty_charge + other_amount + lc_charge);
        needsUpdate = true;
        updatedPageState["total_amount"] = String(total_amount);
      }
    }
    else if(process.env.REACT_APP_CLIENT == "jkl") {
      if (
        total_amount !=
        Math.round(freight + bilty_charge + oda_charge + labour_charge + unloading_charge + pop_charge + detenstion_charge + return_charge + csd_charge + dk_charge)
      ) {
        total_amount =
        Math.round(freight + bilty_charge + oda_charge + labour_charge + unloading_charge + pop_charge + detenstion_charge + return_charge + csd_charge + dk_charge);
        needsUpdate = true;
        updatedPageState["total_amount"] = String(total_amount);
      }
    }
    else if(process.env.REACT_APP_CLIENT == "xpress"){
      if (
        total_amount !=
        Math.round(freight + hamali + detention + loading_charge + unloading_charge + rto - advance)
      ) {
        total_amount =
        Math.round(freight + hamali + detention + loading_charge + unloading_charge + rto - advance)
        needsUpdate = true;
        updatedPageState["total_amount"] = String(total_amount);
      }
    }
    else {
      if(process.env.REACT_APP_CLIENT == "xpress"){
        if (
          total_amount !=
          Math.round(freight + hamali + detention + rto - advance)
        ) {
          total_amount =
          Math.round(freight + hamali + detention + rto - advance)
          needsUpdate = true;
          updatedPageState["total_amount"] = String(total_amount);
        }
      }
      else if(process.env.REACT_APP_CLIENT != "xpress" &&
        total_amount !=
        freight + hamali + door_del_charge + bilty_charge + other_amount + lc_charge
      ) {
        total_amount =
          freight + hamali + door_del_charge + bilty_charge + other_amount + lc_charge;
        needsUpdate = true;
        updatedPageState["total_amount"] = String(total_amount);
      }
    }
  }
  else {
    if (
      total_amount !=
      freight + hamali + door_del_charge + other_amount + lc_charge
    ) {
      total_amount =
        freight + hamali + door_del_charge + other_amount + lc_charge;
      needsUpdate = true;
      updatedPageState["total_amount"] = String(total_amount);
    }
  }
  return [needsUpdate, updatedPageState];
}

export function effectForRowWiseAmount(pageStateDummy) {
  let newItems = [];
  let needsUpdate = false;
  let updatedPageState = {};
  const typeOfWeight = pageStateDummy.type_of_weight;
  const typeOfShipping = pageStateDummy.type_of_shipping;
  
  pageStateDummy.item_in.forEach((item) => {

    let itemCopy = { ...item };
     
    let itemProcessed = false;
    
    if (itemCopy.unit === "") {
      newItems.push(itemCopy);
      itemProcessed = true;
    } else if (itemCopy.unit === "w" || itemCopy.unit === "W") {
      
      if (typeOfWeight === 11) {
        // Calculate weight as cft * 6
        if (itemCopy.cft !== undefined) {
          let cft = parseFloat(itemCopy.cft);
          let weight = parseFloat(itemCopy.weight);
          let rate = parseFloat(itemCopy.rate);
          let amount = parseFloat(itemCopy.amount);

          if (!isNaN(cft)) {
            let calculatedWeight = parseFloat((cft * 6).toFixed(1));
            if (isNaN(weight) || weight !== calculatedWeight) {
              needsUpdate = true;
              itemCopy.weight = String(calculatedWeight);
              newItems.push(itemCopy);
              itemProcessed = true;
            } else if (!isNaN(rate)) {
              // Calculate amount as weight * rate
              let calculatedAmount = parseFloat((calculatedWeight * rate).toFixed(2));
              if (isNaN(amount) || amount !== calculatedAmount) {
                needsUpdate = true;
                itemCopy.amount = String(calculatedAmount);
                newItems.push(itemCopy);
                itemProcessed = true;
              }
            }
          }
        }
      } else if (typeOfWeight === 12) {
        // Handle type_of_weight === "12" (calculate weight from dimensions)
        if (itemCopy.pkgs === "" || itemCopy.l === "" || itemCopy.b === "" || itemCopy.h === "") {
          newItems.push(itemCopy);
          itemProcessed = true;
        } else {
          let pkgs = parseFloat(itemCopy.pkgs);
          let l = parseFloat(itemCopy.l);
          let b = parseFloat(itemCopy.b);
          let h = parseFloat(itemCopy.h);
          let weight = parseFloat(itemCopy.weight);
          let rate = parseFloat(itemCopy.rate);
          let amount = parseFloat(itemCopy.amount);

          let calculatedWeight = parseFloat((((l * b * h * pkgs) / 1728) * 6).toFixed(2));

          // Step 1: Update weight if it hasn't been updated yet
          if (isNaN(weight) || weight !== calculatedWeight) {
            needsUpdate = true;
            itemCopy.weight = String(calculatedWeight);
            newItems.push(itemCopy);
            itemProcessed = true;
          } else if (!isNaN(rate)) {
            // Step 2: When the rate is provided, calculate amount
            let calculatedAmount = calculatedWeight * rate;

            if (isNaN(amount) || amount !== calculatedAmount) {
              needsUpdate = true;
              itemCopy.amount = String(calculatedAmount);
              newItems.push(itemCopy);
              itemProcessed = true;
            } else {
              newItems.push(itemCopy);
              itemProcessed = true;
            }
          } else {
            newItems.push(itemCopy);
            itemProcessed = true;
          }
        }
      } else if (typeOfWeight === 13) {
        if (itemCopy.weight === "" || itemCopy.rate === "" || itemCopy.pkgs === "") {
          newItems.push(itemCopy);
          itemProcessed = true;
        } else {
          let pkgs = parseFloat(itemCopy.pkgs);
          let weight = parseFloat(itemCopy.weight);
          let rate = parseFloat(itemCopy.rate);
          let amount = parseFloat(itemCopy.amount);
          let calculatedAmount = parseFloat((weight * rate).toFixed(2));
          
          if (isNaN(amount) || amount !== calculatedAmount) {
            needsUpdate = true;
            itemCopy.amount = String(calculatedAmount);
            newItems.push(itemCopy);
            itemProcessed = true;
          } else {
            newItems.push(itemCopy);
            itemProcessed = true;
          }
        }
      } else if (typeOfWeight === 14) {
        // Calculate weight as liter * 0.93
        if (itemCopy.liter !== undefined && itemCopy.liter !== "") {
          let liter = parseFloat(itemCopy.liter);
          let weight = parseFloat(itemCopy.weight);
          let rate = parseFloat(itemCopy.rate);
          let amount = parseFloat(itemCopy.amount);

          if (!isNaN(liter)) {
            let calculatedWeight = parseFloat((liter * 0.93).toFixed(2));
            if (isNaN(weight) || weight !== calculatedWeight) {
              needsUpdate = true;
              itemCopy.weight = String(calculatedWeight);
              newItems.push(itemCopy);
              itemProcessed = true;
            } else if (!isNaN(rate)) {
              // Calculate amount as weight * rate
              let calculatedAmount = parseFloat((calculatedWeight * rate).toFixed(2));
              if (isNaN(amount) || amount !== calculatedAmount) {
                needsUpdate = true;
                itemCopy.amount = String(calculatedAmount);
                newItems.push(itemCopy);
                itemProcessed = true;
              }
            }
          }
        }
      }

      if (!itemProcessed && typeOfShipping === 1) {
        if (itemCopy.weight === "" || itemCopy.rate === "") {
          newItems.push(itemCopy);
          itemProcessed = true;
        } else {
          let weight = parseFloat(itemCopy.weight);
          let rate = parseFloat(itemCopy.rate);
          let amount = parseFloat(itemCopy.amount);
          let calculatedAmount = parseFloat((weight * rate).toFixed(2));
          
          if (isNaN(amount) || amount !== calculatedAmount) {
            needsUpdate = true;
            itemCopy.amount = String(calculatedAmount);
            newItems.push(itemCopy);
            itemProcessed = true;
          } else {
            newItems.push(itemCopy);
            itemProcessed = true;
          }
        }
      }
     
    } else if (itemCopy.unit === "c" || itemCopy.unit === "C") {
      // Logic for C unit - similar pattern without returns
      if (typeOfWeight === 11) {
        // Calculate weight as cft * 6
        if (itemCopy.cft !== undefined && itemCopy.cft !== "") {
          let cft = parseFloat(itemCopy.cft);
          let weight = parseFloat(itemCopy.weight);
          let rate = parseFloat(itemCopy.rate);
          let amount = parseFloat(itemCopy.amount);

          if (!isNaN(cft)) {
            let calculatedWeight = parseFloat((cft * 6).toFixed(1));
            if (isNaN(weight) || weight !== calculatedWeight) {
              needsUpdate = true;
              itemCopy.weight = String(calculatedWeight);
              newItems.push(itemCopy);
              itemProcessed = true;
            } else if (!isNaN(rate)) {
              let calculatedAmount = parseFloat((calculatedWeight * rate).toFixed(2));
              if (isNaN(amount) || amount !== calculatedAmount) {
                needsUpdate = true;
                itemCopy.amount = String(calculatedAmount);
                newItems.push(itemCopy);
                itemProcessed = true;
              }
            }
          }
        }
      } else if (typeOfWeight === 12) {
        if (itemCopy.pkgs === "" || itemCopy.l === "" || itemCopy.b === "" || itemCopy.h === "") {
          newItems.push(itemCopy);
          itemProcessed = true;
        } else {
          let pkgs = parseFloat(itemCopy.pkgs);
          let l = parseFloat(itemCopy.l);
          let b = parseFloat(itemCopy.b);
          let h = parseFloat(itemCopy.h);
          let weight = parseFloat(itemCopy.weight);
          let rate = parseFloat(itemCopy.rate);
          let amount = parseFloat(itemCopy.amount);

          let calculatedWeight = parseFloat((((l * b * h * pkgs) / 1728) * 6).toFixed(2));

          if (isNaN(weight) || weight !== calculatedWeight) {
            needsUpdate = true;
            itemCopy.weight = String(calculatedWeight);
            newItems.push(itemCopy);
            itemProcessed = true;
          } else if (!isNaN(rate)) {
            let calculatedAmount = calculatedWeight * rate;

            if (isNaN(amount) || amount !== calculatedAmount) {
              needsUpdate = true;
              itemCopy.amount = String(calculatedAmount);
              newItems.push(itemCopy);
              itemProcessed = true;
            } else {
              newItems.push(itemCopy);
              itemProcessed = true;
            }
          } else {
            newItems.push(itemCopy);
            itemProcessed = true;
          }
        }
      } else if (typeOfWeight === 13) {
        if (itemCopy.pkgs === "" || itemCopy.rate === "") {
          newItems.push(itemCopy);
          itemProcessed = true;
        } else {
          let pkgs = parseFloat(itemCopy.pkgs);
          let rate = parseFloat(itemCopy.rate);
          let amount = parseFloat(itemCopy.amount);
          let calculatedAmount = pkgs * rate;
          
          if (isNaN(amount) || amount !== calculatedAmount) {
            needsUpdate = true;
            itemCopy.amount = String(calculatedAmount);
            newItems.push(itemCopy);
            itemProcessed = true;
          } else {
            newItems.push(itemCopy);
            itemProcessed = true;
          }
        }
      } else if (typeOfWeight === 14) {
        if (itemCopy.liter !== undefined && itemCopy.liter !== "") {
          let liter = parseFloat(itemCopy.liter);
          let weight = parseFloat(itemCopy.weight);
          let rate = parseFloat(itemCopy.rate);
          let amount = parseFloat(itemCopy.amount);

          if (!isNaN(liter)) {
            let calculatedWeight = parseFloat((liter * 0.93).toFixed(2));
            if (isNaN(weight) || weight !== calculatedWeight) {
              needsUpdate = true;
              itemCopy.weight = String(calculatedWeight);
              newItems.push(itemCopy);
              itemProcessed = true;
            } else if (!isNaN(rate)) {
              let calculatedAmount = parseFloat((calculatedWeight * rate).toFixed(2));
              if (isNaN(amount) || amount !== calculatedAmount) {
                needsUpdate = true;
                itemCopy.amount = String(calculatedAmount);
                newItems.push(itemCopy);
                itemProcessed = true;
              }
            }
          }
        }
      }

      if (!itemProcessed && typeOfShipping === 1) {
        if (itemCopy.pkgs === "" || itemCopy.rate === "") {
          newItems.push(itemCopy);
          itemProcessed = true;
        } else {
          let pkgs = parseFloat(itemCopy.pkgs);
          let rate = parseFloat(itemCopy.rate);
          let amount = parseFloat(itemCopy.amount);
          let calculatedAmount = pkgs * rate;
          
          if (isNaN(amount) || amount !== calculatedAmount) {
            needsUpdate = true;
            itemCopy.amount = String(calculatedAmount);
            newItems.push(itemCopy);
            itemProcessed = true;
          } else {
            newItems.push(itemCopy);
            itemProcessed = true;
          }
        }
      }
    } else if (
      itemCopy.unit === "f" ||
      itemCopy.unit === "F" ||
      itemCopy.unit === "t" ||
      itemCopy.unit === "T"
    ) {
      if (itemCopy.rate === "") {
        newItems.push(itemCopy);
        itemProcessed = true;
      } else {
        let rate = parseFloat(itemCopy.rate);
        let amount = parseFloat(itemCopy.amount);
        
        if (isNaN(amount) || amount !== rate) {
          needsUpdate = true;
          itemCopy.amount = String(rate);
          newItems.push(itemCopy);
          itemProcessed = true;
        } else {
          newItems.push(itemCopy);
          itemProcessed = true;
        }
      }
    }
    
    // If item hasn't been processed yet, add it to the list
    if (!itemProcessed) {
      newItems.push(itemCopy);
    }
  });
  if (needsUpdate) {
    updatedPageState = { item_in: newItems };
    return [needsUpdate, updatedPageState];
  } else {
    return [needsUpdate, {}];
  }
}

export function biltyAutoUpdationEffectsDummy(pageStateDummy) {
  let updatedPageState = {};
  let updatedPageStateTotal = {};
  let needsUpdate = false;
  let tempNeedsUpdate = false;
  [tempNeedsUpdate, updatedPageState] = effectForRowWiseAmount(pageStateDummy);
  pageStateDummy = { ...pageStateDummy, ...updatedPageState };
  updatedPageStateTotal = { ...updatedPageStateTotal, ...updatedPageState };
  if (tempNeedsUpdate) {
    needsUpdate = true;
  }
  [tempNeedsUpdate, updatedPageState] = effectForUpdatingRestFieldsBasedOnItems(
    { ...pageStateDummy }
  );
  pageStateDummy = { ...pageStateDummy, ...updatedPageState };
  updatedPageStateTotal = { ...updatedPageStateTotal, ...updatedPageState };
  if (tempNeedsUpdate) {
    needsUpdate = true;
  }

  [tempNeedsUpdate, updatedPageState] = effectForUpdatingTotalAmount({
    ...pageStateDummy,
  });
  pageStateDummy = { ...pageStateDummy, ...updatedPageState };
  updatedPageStateTotal = { ...updatedPageStateTotal, ...updatedPageState };
  if (tempNeedsUpdate) {
    needsUpdate = true;
  }

  if (needsUpdate) {
    return [needsUpdate, updatedPageStateTotal];
  } else {
    return [needsUpdate, {}];
  }
}

export function additionalFilterOnInputForBilty(inputObject,methodType) {
    // let biltyDate = new Date(inputObject.bilty_date);


    if (inputObject?.bilty_date) {
      const originalDate = new Date(inputObject.bilty_date);

      const hours = String(originalDate.getHours()).padStart(2, '0');
      const minutes = String(originalDate.getMinutes()).padStart(2, '0');
      const seconds = String(originalDate.getSeconds()).padStart(2, '0');

      inputObject.bilty_time = `${hours}:${minutes}:${seconds}`;

      // Format bilty_date to remove timezone offset and keep consistent ISO format
      const tzoffset = (new Date()).getTimezoneOffset() * 60000;
      const localISOTime = new Date(originalDate.getTime() - tzoffset).toISOString().slice(0, -1);
      inputObject.bilty_date = localISOTime;
    }

    // let tmpDate = new Date(biltyDate).toLocaleString('sv');
  

  if ("item_in" in inputObject) {
    inputObject.item_in = inputObject.item_in.map((item) => ({
      ...item,
      weight: item.weight ? parseFloat(item.weight) : 0,
      liter: item.liter ? parseFloat(item.liter) : 0,

      l: item.l === "" || item.l == null ? 0 : item.l,
      b: item.b === "" || item.b == null ? 0 : item.b,
      h: item.h === "" || item.h == null ? 0 : item.h,
      cft: item.cft === "" || item.cft == null ? 0 : item.cft,

      truck_size: item.vehicle_size,
    }));
  }

  if (inputObject.type_of_shipping === 1) {
    if (!inputObject.mode_of_transportation || inputObject.mode_of_transportation === "") {
      throw new Error("Mode of transportation must be selected.");
    }

    if ("item_in" in inputObject) {
      inputObject.item_in = inputObject.item_in.map((item) => ({
        ...item,
        l: "0",
        b: "0",
        h: "0",
        inch_cm: "7",
        // weight: "0",
        // pkgs: "0",
        cft: "0",
        // unit: "F",
        liter: "0",
      }));
    }
  } else {
    if ("item_in" in inputObject) {
      inputObject.item_in = inputObject.item_in.map((item) => ({
        ...item,
        cft: item.cft === "" || item.cft === null ? "0" : item.cft,
        inch_cm: (!item.inch_cm && item.inch_cm !== 0) ? "7" : item.inch_cm,
      }));
    }
  }

  if (
    inputObject.eway_bill_info &&
    inputObject.eway_bill_info.length == 1 &&
    inputObject.eway_bill_info[0].eway_bill_no == ""
  ) {
    delete inputObject.eway_bill_info;
  }

  if (inputObject.actual_weight == "" || inputObject.actual_weight == null) {
    if(process.env.REACT_APP_CLIENT == "jkl" ) {
      inputObject.actual_weight = inputObject.charge_weight;
    } else {
      inputObject.actual_weight = "0";
    }
  }

  if (
    inputObject.consignor_gst == "N.A" ||
    inputObject.consignor_gst == "n.a"
  ) {
    inputObject.consignor_gst = null;
  }
  if (
    inputObject.consignee_gst == "N.A" ||
    inputObject.consignee_gst == "n.a"
  ) {
    inputObject.consignee_gst = null;
  }

  let dummyObject = lodash.cloneDeep(inputObject);

  if (dummyObject.is_crossing == "N" || dummyObject.is_crossing == "n") {
    dummyObject.transporter_id = null;
    dummyObject.transporter_name = null;
    // dummyObject.suffix = null;
  }
  delete dummyObject.is_crossing;

  // Convert bilty_no alphabet characters to uppercase
  if (dummyObject.bilty_no) {
    dummyObject.bilty_no = dummyObject.bilty_no
      .split("")
      .map((char) => (/[a-z]/i.test(char) ? char.toUpperCase() : char))
      .join("");
  }

  if (dummyObject.transporter_freight == null || dummyObject.transporter_freight === "") {
    dummyObject.transporter_freight = 0;
  }
  

  if (dummyObject.is_multi_point === 0 || dummyObject.is_multi_point === 1) {
    dummyObject.is_multi_point = dummyObject.is_multi_point.toString();
  }  
  
  // Removing entries with blank string.
  for (let key in dummyObject) {
    if (key !== "charge_weight" && dummyObject[key] == "") {
      dummyObject[key] = null;
    }
  }

  // Removing new row from tables
  if ("item_in" in dummyObject) {
    for (let i = 0; i < dummyObject.item_in.length; i++) {
      delete dummyObject.item_in[i].new_row;
      dummyObject.item_in[i].truck_size = dummyObject.item_in[i].vehicle_size;
      delete dummyObject.item_in[i].vehicle_size;
    }
  }

  if (String(dummyObject.pay_type) === "4" && Array.isArray(dummyObject.item_in)) {
    const invalidItem = dummyObject.item_in.find(
      (item) => !item.item_id || item.item_id === ""
    );
    if (invalidItem) {
      throw new Error("Please fetch item from suggestion when pay type is 'To Be Billed'");
    }
  }

  if ("eway_bill_info" in dummyObject && dummyObject.eway_bill_info != null) {
    for (let i = 0; i < dummyObject.eway_bill_info.length; i++) {
      delete dummyObject.eway_bill_info[i].new_row;
    }
  }
  if(!dummyObject.suffix) {
      dummyObject.suffix = "null";
  }

//   if(dummyObject.suffix)
  return dummyObject;
}

export function additionalFilterOnResponseForGetEwb(inputObject) {
  return inputObject.eway_bill_info[0];
}
